export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Общая сумма к списанию"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Комиссия"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Инфо"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["К зачислению"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Невозможно рассчитать сумму"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Недостаточно средств для проведения платежа"])}
}